import React from 'react'

import style from './index.css'

export const Radio = ({ inputProps, labelText, labelProps }) => (
  <label {...labelProps} className={`${style.container} ${labelProps.className || ''}`}>
    {labelText}
    <input type="radio" {...inputProps} />
    <span className={style.checkmark} />
  </label>
)
